import { createContext } from "react";

export interface SetupContextType {
  bootstrapped?: boolean;
  setBootStrapped(): void;
}

export const SetupContext = createContext<SetupContextType | undefined>(
  undefined
);
